import { createContext, ReactNode, useContext, useReducer } from "react"
const defaultState:any = { amount:0 }
export type Dispatch = (action:any) => void;
export type State = typeof defaultState
interface AddMoneyContextInterface {
    state:typeof defaultState,
    dispatch: Dispatch
}
interface Action {
    type:'ADD_MONEY',
    payload: ''
}
const AddMoneyContext = createContext<AddMoneyContextInterface | null>(null);

function addMoneyReducer(state: State, action: Action) {
    const { type, payload } = action;
    switch (type) {
        case 'ADD_MONEY':
            return {
                ...state,
                amount: payload
            }
        default:
            return state;
    }
}

export function AddMoneyProvider({children}:{children: ReactNode}) {
    const [state, dispatch] = useReducer(addMoneyReducer, defaultState)

    return <AddMoneyContext.Provider value = {{state, dispatch}} >
        {children}
        </AddMoneyContext.Provider>
}

export function useAddMoney() {
    const context = useContext(AddMoneyContext)
    if(!context) throw new Error("useAddMoney must be used inside addmoneyProvider");

    return context;
}